import { gql } from '@apollo/client';

const GET_JOURNAL_ENTRIES_1099 = gql`
  query journalEntries1099($input: JournalEntry1099Input!) {
    journalEntries1099(input: $input) {
      id
      amount
      vendor
      documentDate
      commentCount
      fileId
      source1099
      contractorName
      contractorId
      dataEntries {
        id
        ledgerAccountId
        amount
        entryType
        ledgerName
      }
      clientComments {
        body
        createdOn
      }
      internalNotes {
        body
        createdOn
        flagged
      }
    }
  }
`;

/**
 * Returns a refetchQueries-compatible array for GET_JOURNAL_ENTRIES_1099.
 * Returns empty array if clientId is not provided, since `skip` does not work in refetchQueries.
 */
const getJournalEntries1099RefetchQuery = (clientId: string | undefined) => {
  if (!clientId) return [];
  return [
    {
      query: GET_JOURNAL_ENTRIES_1099,
      variables: { input: { clientId } },
      context: { useV2: true },
    },
  ];
};

const GET_CONTRACTOR_LIST_WITH_INSTANCES = gql`
  query contractors($clientId: ID!) {
    contractors(clientId: $clientId) {
      id
      name
      transactionCount
    }
  }
`;

export {
  GET_JOURNAL_ENTRIES_1099,
  GET_CONTRACTOR_LIST_WITH_INSTANCES,
  getJournalEntries1099RefetchQuery,
};
